import type { ReactNode } from "react"
import type { Me } from "@shared/api"
import { useAuth } from "../context/AuthContext"
import "../styles/shell.scss"

/**
 * Chrome de la app.
 *
 * El hermano (tablero de reuniones) usa un sidebar de 240 px con un item por vista.
 * Acá hay DOS vistas, y la navegación son dos tabs (`nav`, las manda App) en la
 * misma barra superior: un sidebar para dos items seguiría siendo una columna casi
 * vacía. El shell sigue siendo presentacional — no sabe de query strings.
 *
 * `wide`: la pestaña de solicitudes trae una columna de texto libre (la
 * justificación) y a 900px quedaría aplastada; el ancho lo decide App por vista.
 *
 * El email a la vista no es decorativo: el pool auth.users es compartido con las
 * otras apps internas, así que saber CON QUÉ CUENTA se está mirando es lo que evita
 * el "a mí no me aparece" de alguien logueado con la cuenta equivocada.
 */
export function AppShell({
  me,
  nav,
  wide,
  children,
}: {
  me: Me
  nav?: ReactNode
  wide?: boolean
  children: ReactNode
}) {
  const { signOut } = useAuth()

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar-brand">
          <span className="topbar-title">Horas extra</span>
          <span className="topbar-sub">Tablero admin</span>
        </div>
        {nav}
        <div className="topbar-account">
          <span className="account-email" title={me.email ?? undefined}>
            {me.email}
          </span>
          <button type="button" className="btn btn-sm" onClick={() => void signOut()}>
            Cerrar sesión
          </button>
        </div>
      </header>
      <main className={wide ? "page page--wide" : "page"}>{children}</main>
    </div>
  )
}
